<template>
    <div>
    <span  v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
    <div style="text-align:left;padding:20px;background-color:#ffffff;">
           <v-table style="background-color:#ffffff;"><tr>

            <td>
           <h4 class="text-h5" v-if="'UTA_Adapter' in item">
                {{ item["UTA_Adapter"]["gene_name"] }}:{{ item["UTA_Adapter"]["variant_exchange"] }}
           </h4></td></tr></v-table>
         </div>

        <v-tabs
            bg-color="#ffffff"
            color="#01579B"
            align-tabs="left"
        >
            <v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-variant-details-q/${ item['UTA_Adapter']['gene_name'] }:${ item['UTA_Adapter']['variant_exchange'] }`
                         }"
                ><v-btn id="variant-nav-bar-summary" elevation="3" style="padding:0;">
                    <span
                        v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='summary', 'var-nav-bar-btn-default': this.varPage != 'summary' }">
                        Summary
                    </span>
                 </v-btn>
                </router-link>
            </v-tab>

            <v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-variant-details-q/${ item['UTA_Adapter']['gene_name'] }:${ item['UTA_Adapter']['variant_exchange'] }/treatments`,
                     }"
                >
                <v-btn id="variant-nav-bar-treatments" elevation="3" style="padding:0;">
                     <span
                             v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='treatments', 'var-nav-bar-btn-default': this.varPage != 'treatments' }"
                     >
                        Treatments
                     </span>
                 </v-btn>
                </router-link>
            </v-tab>

            <v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-variant-details-q/${ item['UTA_Adapter']['gene_name'] }:${ item['UTA_Adapter']['variant_exchange'] }/pathogenicity`,
                     }"
                ><v-btn id="variant-nav-bar-protein" elevation="3" style="padding:0;">
                 <span
                    v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='pathogenicity', 'var-nav-bar-btn-default': this.varPage != 'pathogenicity' }"
                 >
                    Pathogenicity
                 </span>
                    </v-btn>
                </router-link>
            </v-tab>

            <v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-variant-details-q/${ item['UTA_Adapter']['gene_name'] }:${ item['UTA_Adapter']['variant_exchange']}/protein`,
                     }"
                ><v-btn id="variant-nav-bar-protein" elevation="3" style="padding:0;">
                 <span
                    v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='protein', 'var-nav-bar-btn-default': this.varPage != 'protein' }"
                 >
                    Protein
                 </span>
                    </v-btn>
                </router-link>
            </v-tab>
            <v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-variant-details-q/${ item['UTA_Adapter']['gene_name'] }:${ item['UTA_Adapter']['variant_exchange']}/transcripts`,
                     }"
                ><v-btn id="variant-nav-bar-transcripts" elevation="3" style="padding:0;">
                 <span
                    v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='transcripts', 'var-nav-bar-btn-default': this.varPage != 'transcripts' }"
                 >
                    Transcripts
                 </span>
                    </v-btn>
                </router-link>
            </v-tab>
            <v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-variant-details-q/${ item['UTA_Adapter']['gene_name'] }:${ item['UTA_Adapter']['variant_exchange']}/gene-expression`,
                     }"
                ><v-btn id="variant-nav-bar-gene-expression" elevation="3" style="padding:0;">
                 <span
                    v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='gene-expression', 'var-nav-bar-btn-default': this.varPage != 'gene-expression' }"
                 >
                    Gene expression
                 </span>
                    </v-btn>
                </router-link>
            </v-tab>
            <v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-variant-details-q/${ item['UTA_Adapter']['gene_name'] }:${ item['UTA_Adapter']['variant_exchange']}/variant-classification`,
                     }"
                ><v-btn id="variant-nav-bar-variant-classification" elevation="3" style="padding:0;">
                 <span
                    v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='variant-classification', 'var-nav-bar-btn-default': this.varPage != 'variant-classification' }"
                 >
                    Classification
                 </span>
                    </v-btn>
                </router-link>
            </v-tab>

            <!--<v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-variant-details-q/${ item['UTA_Adapter']['gene_name'] }:${ item['UTA_Adapter']['variant_exchange'] }/pathways`,
                     }"
                ><v-btn id="var-nav-bar-pathways" elevation="3" style="padding:0;">
                <span
                    v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='pathways', 'var-nav-bar-btn-default': this.varPage != 'pathways' }"
                 >
                    Pathways</span>
                 </v-btn>
                </router-link>
            </v-tab>-->

            <!--<v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-variant-details-q/${ item['UTA_Adapter']['gene_name'] }:${ item['UTA_Adapter']['variant_exchange'] }/nearby-treatments`,
                     }"
                >
                <v-btn id="variant-nav-bar-treatments" elevation="3" style="padding:0;">
                     <span
                             v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='nearby-treatments', 'var-nav-bar-btn-default': this.varPage != 'nearby-treatments' }"
                     >
                        Nearby Biomarkers
                     </span>
                 </v-btn>
                </router-link>
            </v-tab>-->

        </v-tabs>
        </span>
    </div>
</template>
<script>
import variant_annotation from "@/methods/variant_annotation";

export default {
    name: 'VariantViewNavBar',
    props: {
        item: {}
    },
    data () {
        return {
            varPage: "summary",
        }
    },
    methods: {
    },
    created: async function() {
        if (this.$route.path) {
            let route_parts = this.$route.path.split("/")
            if (route_parts.length>3) {
                this.varPage = route_parts[ route_parts.length-1 ]
            } else {
                this.varPage = "summary"
            }
        }
    },
    mounted: async function() {

    }
}
</script>
<style>
.var-nav-bar-btn-selected {
    background-color: #58b3e0;
    padding-left: 20px; padding-right: 20px;
    padding-top: 10px; padding-bottom: 10px;
}
.var-nav-bar-btn-default {
    background-color: #FFFFFF;
    padding-left: 20px; padding-right: 20px;
    padding-top: 10px; padding-bottom: 10px;
}
</style>
